import { catchError } from 'rxjs/operators';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "./api.service";
import * as i2 from "./helper.service";
var FireSafetyDocsService = /** @class */ (function () {
    /**
     * Class constructor
     */
    function FireSafetyDocsService(apiService, helperService) {
        this.apiService = apiService;
        this.helperService = helperService;
    }
    /**
     * Create a new fire safety doc
     *
     * @since 1.0.0
     *
     * @param data FireSafetyDoc data
     * @returns Observable<any>
     */
    FireSafetyDocsService.prototype.create = function (data) {
        return this.apiService.apiCall("POST", "fire-safety-docs", data);
    };
    /**
     * Get Groundings list for given query params
     *
     * @since 1.0.0
     *
     * @param [start] Query left offset
     * @param [limit] Results number
     * @param [sort] Sorting field name
     * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
     * @param [search] Filtering object with fildering data string
     */
    FireSafetyDocsService.prototype.getList = function (companyId, start, limit, sort, sortVersus, search) {
        var params = { start: start, limit: limit, sort: sort, sortVersus: sortVersus };
        if (search) {
            Object.keys(search).forEach(function (key) {
                var newParamKey = "search[" + key + "]";
                var newParamValue = search[key];
                params[newParamKey] = newParamValue;
            });
        }
        return this.apiService.apiCall('GET', "fire-safety-docs/" + companyId, params);
    };
    /**
     * Get the fire safety doc
     *
     * @since 1.0.0
     *
     * @param docId FireSafetyDoc Id
     * @returns Observable<any>
     */
    FireSafetyDocsService.prototype.get = function (companyId, docId) {
        return this.apiService.apiCall("GET", "fire-safety-docs/" + companyId + "/" + docId);
    };
    /**
     * Get the fire safety doc
     *
     * @since 1.0.0
     *
     * @param docId FireSafetyDoc Id
     * @returns Observable<any>
     */
    FireSafetyDocsService.prototype.getDocByView = function (docId) {
        return this.apiService.apiCall("GET", "fire-safety-docs/doc-by-view/" + docId);
    };
    /**
     * Update a fire safety doc
     *
     * @since 1.0.0
     *
     * @param data FireSafetyDoc data
     * @returns Observable<any>
     */
    FireSafetyDocsService.prototype.update = function (companyId, docId, data) {
        return this.apiService.apiCall("PATCH", "fire-safety-docs/" + companyId + "/" + docId, data);
    };
    /**
     * Delete a fire safety doc
     *
     * @since 1.0.0
     *
     * @param data FireSafetyDoc data
     * @returns Observable<any>
     */
    FireSafetyDocsService.prototype.delete = function (companyId, docId) {
        return this.apiService.apiCall("DELETE", "fire-safety-docs/" + companyId + "/" + docId);
    };
    /**
     * This gets the occupied space of fire safety documents, in the measure of MB or GB
     *
     * @since 1.0.0
     */
    FireSafetyDocsService.prototype.getOccupiedSpace = function (companyId) {
        return this.apiService.apiCall('GET', "fire-safety-docs/occupied-space/" + companyId);
    };
    /**
     * Get an exportation file of all fire safety docs
     *
     * @since 1.0.0
     */
    FireSafetyDocsService.prototype.getExport = function (companyId) {
        var _this = this;
        return this.apiService.apiCall('GET', "fire-safety-docs/export/" + companyId, {}, { responseType: 'blob' })
            .pipe(catchError(function (err) {
            return _this.helperService.parseErrorBlob(err);
        }));
    };
    FireSafetyDocsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FireSafetyDocsService_Factory() { return new FireSafetyDocsService(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(i2.HelperService)); }, token: FireSafetyDocsService, providedIn: "root" });
    return FireSafetyDocsService;
}());
export { FireSafetyDocsService };
